import './AppLoading.css';

/** Public, inert shell: never mount account hooks before session validation. */
export function AppLoading({
  error = '',
  onRetry,
}: {
  error?: string;
  onRetry: () => void;
}) {
  return (
    <main className="arena-app app-loading">
      <div className="top-bar app-loading-header" aria-hidden="true">
        <span className="rd-logo">
          <span>R</span>
          <i />
          <span>D</span>
        </span>
        <div className="nav-pill app-loading-placeholder" />
        <div className="app-loading-account app-loading-placeholder" />
      </div>
      <div className="app-loading-content">
        <div className="app-loading-card" aria-hidden="true">
          <div className="app-loading-token app-loading-placeholder" />
          <div className="app-loading-line app-loading-placeholder" />
          <div className="app-loading-chart app-loading-placeholder" />
        </div>
        <div className="app-loading-status">
          {error ? (
            <>
              <p role="alert">{error}</p>
              <button type="button" className="primary" onClick={onRetry}>
                Try again
              </button>
            </>
          ) : (
            <p role="status">Loading your account…</p>
          )}
        </div>
      </div>
    </main>
  );
}
